import { render } from "./TraineeHeader.vue?vue&type=template&id=244076db&scoped=true"
import script from "./TraineeHeader.vue?vue&type=script&lang=js"
export * from "./TraineeHeader.vue?vue&type=script&lang=js"

import "./TraineeHeader.vue?vue&type=style&index=0&id=244076db&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-244076db"]])

export default __exports__